import { render, staticRenderFns } from "./CardContentSmallSize.vue?vue&type=template&id=f796e31e&scoped=true&"
import script from "./CardContentSmallSize.vue?vue&type=script&lang=js&"
export * from "./CardContentSmallSize.vue?vue&type=script&lang=js&"
import style0 from "./CardContentSmallSize.vue?vue&type=style&index=0&id=f796e31e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f796e31e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
